
import { HashRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import Navbar from './component/Navbar/Navbar';
import Login from './component/Login/Login';

function App() {
  return (
    <>      
      <HashRouter>
        <Navbar/>
        <Routes>
          <Route path='/' element={<Login/>}/>
        </Routes>
      </HashRouter>
    </>
  );
}

export default App;
